import { render } from "./CommunicationDataScreen.vue?vue&type=template&id=621ac3d5&scoped=true&lang=html"
import script from "./CommunicationDataScreen.vue?vue&type=script&lang=js"
export * from "./CommunicationDataScreen.vue?vue&type=script&lang=js"

import "./CommunicationDataScreen.vue?vue&type=style&index=0&id=621ac3d5&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/tech_touch_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621ac3d5"]])

export default __exports__